import {SubscriptionTypes} from '../ActionTypes/SubscriptionTypes';

let initialSate = {
  CreateSubscriptionHistoryList: [],
  CreateSubscriptionHistoryPagination: null,
};

const SubscriptionReducer = (state = initialSate, action) => {
  switch (action.type) {
    case SubscriptionTypes.GET_SUBSCRIPTION_HISTORY:
      let CreateSubscriptionHistoryList_Copy = [];
      CreateSubscriptionHistoryList_Copy = [
        ...state.CreateSubscriptionHistoryList,
        ...action.payload.data,
      ];
      state = {
        ...state,
        CreateSubscriptionHistoryPagination: action.payload,
        CreateSubscriptionHistoryList: CreateSubscriptionHistoryList_Copy,
      };
      break;

    case SubscriptionTypes.CLEAR_SUBSCRIPTION_HISTORY:
      state = {
        CreateSubscriptionHistoryList: [],
        CreateSubscriptionHistoryPagination: null,
      };
      break;
  }
  return state;
};

export default SubscriptionReducer;
